export const faqItems = [
  {
    id: 1,
    q: '爆瓜网的信息来源可靠吗？',
    a: '我们建立了严格的多源交叉验证机制。每条信息都经过至少两个独立信源确认后才会发布，并标注可信度等级。对于未经核实的信息，我们会明确标注"待确认"，绝不为了流量牺牲准确性。',
  },
  {
    id: 2,
    q: '如何第一时间收到最新的娱乐爆料？',
    a: '推荐下载爆瓜网APP并开启推送通知，重大爆料会在核实后的第一时间推送给你。你也可以关注我们的微信公众号和微博账号，多渠道获取最新资讯。',
  },
  {
    id: 3,
    q: '我有一条独家爆料线索，怎么联系你们？',
    a: '欢迎通过页面上方的"爆料投稿"入口提交线索。我们承诺对报料人信息严格保密，对于重大独家爆料还会提供相应的线索奖励。也可以在微博私信 @爆瓜网 官方账号。',
  },
  {
    id: 4,
    q: '爆瓜网的内容更新频率是怎样的？',
    a: '我们实行7×24小时的轮班更新机制，确保早中晚三个时段都有新鲜内容。重大突发事件会在15分钟内完成核实并发布，日常资讯保持每小时至少3条更新的频率。',
  },
  {
    id: 5,
    q: '为什么有些新闻的评论区关闭了？',
    a: '为了维护健康的讨论环境，对于涉及敏感话题或容易引发争议的内容，我们会暂时关闭或限制评论功能。这是平台主动承担社会责任的表现，感谢你的理解。',
  },
  {
    id: 6,
    q: '爆瓜网有原创内容团队吗？',
    a: '我们拥有一支由资深娱乐记者、影视评论人和新媒体编辑组成的原创团队。除了报道最新资讯外，团队还会定期产出深度专题、人物专访和行业分析等原创内容。',
  },
];